import { render, staticRenderFns } from "./vr_v1.vue?vue&type=template&id=3bd075a1&scoped=true&"
import script from "./vr_v1.vue?vue&type=script&lang=js&"
export * from "./vr_v1.vue?vue&type=script&lang=js&"
import style0 from "./vr_v1.vue?vue&type=style&index=0&id=3bd075a1&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bd075a1",
  null
  
)

export default component.exports